// Filtre d'arrondissement : alimenté par GET /arrondissements quand l'API l'expose.
import { Selection } from '@cc/ui';
import { useQuery } from '@tanstack/react-query';
import { requete } from '../../api/client';
import { ErreurApi } from '../../api/erreurs';

interface Arrondissement {
  id: string;
  libelle?: string;
  nom?: string;
}

export function useArrondissements() {
  return useQuery({
    queryKey: ['arrondissements'],
    queryFn: ({ signal }) => requete<{ elements: Arrondissement[] }>('/arrondissements', { signal }).then((r) => r.elements),
    retry: false,
    staleTime: 10 * 60_000,
  });
}

export function SelecteurArrondissement({ valeur, onChanger }: { valeur: string; onChanger: (v: string) => void }) {
  const a = useArrondissements();
  const indisponible = a.error instanceof ErreurApi && a.error.routeIndisponible;
  const options = [{ valeur: '', libelle: 'Tous les arrondissements' }, ...(a.data ?? []).map((x) => ({ valeur: x.id, libelle: x.libelle ?? x.nom ?? x.id }))];
  return (
    <Selection
      libelle="Arrondissement"
      value={valeur}
      onChange={(e) => onChanger(e.target.value)}
      options={options}
      disabled={!a.data || a.data.length === 0}
      aide={
        a.isPending
          ? 'Chargement des arrondissements'
          : indisponible
            ? 'La liste des arrondissements n\'est pas encore exposée par l\'API : tous les arrondissements sont comptés.'
            : a.error
              ? 'Liste des arrondissements indisponible : tous les arrondissements sont comptés.'
              : a.data?.length === 0
                ? 'Aucun arrondissement saisi pour cette collectivité.'
                : undefined
      }
    />
  );
}
